import { render } from "./proportion-sales.vue?vue&type=template&id=40324bd0&scoped=true"
import script from "./proportion-sales.vue?vue&type=script&lang=ts"
export * from "./proportion-sales.vue?vue&type=script&lang=ts"

import "./proportion-sales.vue?vue&type=style&index=0&id=40324bd0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-40324bd0"

export default script